import { weekLabel } from './format'
import { isoWeekNumber } from './weeks'

/**
 * Right-click menu for one week column: add a week before/after it, or (only
 * at the true first/last column of the project's own axis) remove it.
 */
export default function ColumnContextMenu({ colMenu, setColMenu, onAddBefore, onAddAfter, onRemove, t }) {
  if (!colMenu) return null
  return (
    <>
      <div className="fixed inset-0 z-40" onClick={() => setColMenu(null)}
           onContextMenu={e => { e.preventDefault(); setColMenu(null) }} />
      <div className="fixed z-50 bg-white border border-gray-200 rounded-lg shadow-lg text-xs py-1 min-w-48"
           style={{
             left: Math.min(colMenu.x, window.innerWidth - 210),
             top: Math.min(colMenu.y, window.innerHeight - 140),
           }}>
        <div className="px-3 py-1 text-[11px] text-gray-400 truncate border-b border-gray-100">
          S{isoWeekNumber(colMenu.week.monday)} · {weekLabel(colMenu.week.monday)}
        </div>
        <button
          onClick={() => { setColMenu(null); onAddBefore() }}
          className="block w-full text-left px-3 py-1.5 hover:bg-gray-50">
          {t('staffing.contextAddWeekBefore')}
        </button>
        <button
          onClick={() => { setColMenu(null); onAddAfter() }}
          className="block w-full text-left px-3 py-1.5 hover:bg-gray-50">
          {t('staffing.contextAddWeekAfter')}
        </button>
        {(colMenu.isFirst || colMenu.isLast) && (
          <button
            onClick={() => { const edge = colMenu.isLast ? 'end' : 'start'; setColMenu(null); onRemove(edge) }}
            className="block w-full text-left px-3 py-1.5 hover:bg-red-50 text-red-600 border-t border-gray-100">
            {t('staffing.contextRemoveWeek')}
          </button>
        )}
      </div>
    </>
  )
}
